import React from "react";
import Question, { QuestionType } from "../../types/Question";
import QuestionMultipleChoice from "../Questions/QuestionMultipleChoice";
import { Paper } from "@material-ui/core";
import CheckIcon from "@material-ui/icons/Check";
import ErrorIcon from "@material-ui/icons/Close";

interface IProps {
  question: Question;
  index: number;
  onChange: (index: number, question: Question) => void;
}

export default function TrainingQuestion(props: IProps) {
  const { question, index, onChange } = props;

  function getAnswers() {
    switch (question.questionType) {
      case QuestionType.MultipleChoiceMulti:
      case QuestionType.MultipleChoiceOne:
      case QuestionType.TrueFalse:
      case QuestionType.WithResponse:
      case QuestionType.WithResponseHr:
        return (
          <QuestionMultipleChoice
            index={index}
            question={question}
            onChange={(index: number, question: Question) => {
              onChange(index, question);
            }}
          />
        );
      default:
        return null;
    }
  }

  function getIcon() {
    switch (question.status) {
      case "correct":
        return (
          <div style={{ marginBottom: 8 }}>
            <CheckIcon />
          </div>
        );
      case "wrong":
        return (
          <div style={{ marginBottom: 8 }}>
            <ErrorIcon />
          </div>
        );
      default:
        return null;
    }
  }

  return (
    <Paper
      style={{ padding: "24px 32px", marginTop: 12, marginBottom: 24 }}
      className={question.status}
    >
      <div
        style={{
          alignItems: "center",
          marginBottom: 10
        }}
        className={question.status}
      >
        {getIcon()}
        <h4 style={{ margin: 0, flex: 1 }}>{question.questionText}</h4>
        {question.questionScenario ? (
          <div style={{ fontSize: 14, marginTop: 15 }}>
            {question.questionScenario}
          </div>
        ) : null}
      </div>
      <div style={{ marginLeft: 15 }}>{getAnswers()}</div>
    </Paper>
  );
}
